import Vue from 'vue'
import Router from 'vue-router'
import passwordReset from '@/views/switch/passwordReset.vue'
import switchNotice from '@/views/switch/notice/switchNotice.vue'
import activeAccount from '@/views/switch/activeAccount.vue'
import inviteSwitch from '@/views/switch/inviteSwitch.vue'
import downloadFiles from '@/views/switch/file.vue'
import switchOrder from '@/views/switch/order.vue'
import accept from '@/views/switch/invite/accept.vue'
import acceptNew from '@/views/switch/invite/acceptNew.vue'
// import inviteNew from '@/views/entrance/inviteNew.vue'
import resetSwitch from '@/views/switch/resetAccount.vue'
import requestSwitch from '@/views/switch/requestToSend.vue'
import Login from '@/views/entrance/login.vue'
import Register from '@/views/entrance/register.vue'
import Complete from '@/views/entrance/complete.vue'
import Index from '@/views/box/main/index.vue'
import Inbox from '@/views/box/main/inbox.vue'
import History from '@/views/box/main/history.vue'
import Outbox from '@/views/box/main/outbox.vue'
import Retrieve from '@/views/box/main/retrieve.vue'
import Initial from '@/views/box/main/initial.vue'
import Terms from '@/views/entrance/terms.vue'
import Phone from '@/views/entrance/phone.vue'
import Transfer from '@/app/views/transfer.vue'
import Download from '@/views/box/main/download.vue'
import Upload from '@/views/box/main/upload.vue'
import Portal from '@/app/views/portal.vue'
import Settings from '@/app/views/settings.vue'
import Statistics from '@/views/box/main/other/statistics.vue'
import Notification from '@/views/box/main/other/notification.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [
    {
      path: '/app/account-active',
      name: 'account-active',
      component: activeAccount
    },
    {
      path: '/app/account-invite',
      name: 'account-invite',
      component: inviteSwitch
    },
    {
      path: '/app/accept',
      name: 'accept',
      component: accept
    },
    {
      path: '/app/accept-new',
      name: 'accept-new',
      component: acceptNew
    },
    {
      path: '/app/account-reset',
      name: 'account-reset',
      component: resetSwitch
    },
    {
      path: '/app/request-send',
      name: 'request-send',
      component: requestSwitch
    },
    {
      path: '/app/order',
      name: 'order',
      component: switchOrder
    },
    {
      path: '/app/reset',
      name: 'reset',
      component: passwordReset
    },
    {
      path: '/app/notice',
      name: 'notice',
      component: switchNotice
    },
    {
      path: '/app/download-files',
      name: 'download-files',
      component: downloadFiles
    },
    {
      path: '/app/login',
      name: 'login',
      component: Login
    },
    {
      path: '/app/register',
      name: 'register',
      component: Register
    },
    {
      path: '/app/complete',
      name: 'complete',
      component: Complete
    },
    {
      path: '/app/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/app/phone',
      name: 'phone',
      component: Phone
    },
    {
      path: '/app/initial',
      component: Initial,
      meta: {
        auth: true
      }
    },
    {
      path: '/app/upload/:id',
      component: Upload,
      meta: {
        auth: true
      }
    },
    {
      path: '/app/download/:id',
      component: Download,
      meta: {
        auth: true
      }
    },
    {
      path: '/app/workspace/',
      component: Index,
      meta: {
        auth: true
      },
      redirect: '/app/workspace/inbox',
      children: [
        {
          path: 'inbox',
          meta: {
            auth: true
          },
          name: 'inbox',
          component: Inbox
        },
        {
          path: 'outbox',
          meta: {
            auth: true
          },
          name: 'outbox',
          component: Outbox
        },
        {
          path: 'retrieve',
          meta: {
            auth: true
          },
          name: 'retrieve',
          component: Retrieve,
        },
        {
          path: 'transfer',
          meta: {
            auth: true
          },
          name: 'transfer',
          component: Transfer
        },
        {
          path: 'history',
          meta: {
            auth: true
          },
          name: 'history',
          component: History
        },
        {
          path: 'portal',
          meta: {
            auth: true
          },
          name: 'portal',
          component: Portal
        },
        {
          path: 'statistics',
          meta: {
            auth: true
          },
          name: 'statistics',
          component: Statistics
        },
        {
          path: 'notification',
          meta: {
            auth: true
          },
          name: 'notification',
          component: Notification
        },
        {
          path: 'settings',
          meta: {
            auth: true
          },
          name: 'settings',
          component: Settings
        },
      ]
    },
    {
      path: '*',
      meta: {
        auth: true
      },
      redirect: '/app/workspace/inbox'
    },
    {
      path: '*',
      redirect: '/app/login'
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next({
        path: '/app/login'
      })
    }
  } else {
    next()
  }
})
export default router
